<div *ngIf="!isRouterReady" class="app-loading-container">
  <loading-wheel></loading-wheel>
</div>

<core-notification
  *ngIf="showEulaSuccessNotification"
  class="eula-success-notification"
  data-testid="eula-success-notification"
  label="Success: "
  [message]="eulaNotificationMessage"
  variant="inline"
  state="success"
  timer=""
  (onNotificationClosed)="onEulaNotificationClosed()"
  reusable="true"
>
</core-notification>

<div *ngIf="isRouterReady && showAppContent">
  <app-header
    [showSponsorDropdown]="showSponsorDropdown"
    [sponsors]="headerSponsors"
    [selectedSponsor]="headerSelectedSponsor"
    (profileClicked)="onHeaderProfileClick($event)"
    (sponsorApplyClicked)="onHeaderSponsorApply($event)"
  ></app-header>

  <div class="app-body">
    <kwa-platform-nav [items]="sidebarItems" collapsible="true"></kwa-platform-nav>
    <div
      class="app-content"
      [ngClass]="{
        'app-content-collapsed': sidebarCollapsed,
        'app-content-expanded': !sidebarCollapsed
      }"
    >
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
